import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Crown, Check, Zap, Rocket, Shield, ArrowLeft } from 'lucide-react';

/**
 * SubscriptionPage - VIP upgrade landing page
 * Shown when non-VIP users try to access build features
 */
const SubscriptionPage = () => {
    const navigate = useNavigate();

    const features = [
        { icon: Zap, text: 'Unlimited AI-powered website builds' },
        { icon: Rocket, text: 'Full AI mode with live images & fonts' },
        { icon: Shield, text: 'Priority support & faster builds' },
        { icon: Crown, text: 'Access to all premium templates' },
    ];

    const handleContactAdmin = () => {
        // In a real app, this could open a chat or mailto link
        window.location.href = 'mailto:admin@digitalninja.app?subject=VIP Access Request';
    };

    return (
        <div className="min-h-screen bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 flex items-center justify-center p-4">
            <Card className="max-w-lg w-full bg-slate-900/80 border-slate-700/50 p-8 rounded-2xl backdrop-blur-sm">
                {/* Header */}
                <div className="text-center mb-8">
                    <div className="inline-flex items-center justify-center p-4 rounded-full bg-gradient-to-br from-amber-500/20 to-orange-500/20 border border-amber-500/30 mb-4">
                        <Crown className="h-10 w-10 text-amber-400" />
                    </div>
                    <h1 className="text-3xl font-bold text-white mb-2">
                        Upgrade to VIP
                    </h1>
                    <p className="text-slate-400">
                        Unlock the full power of Digital Ninja AI Builder
                    </p>
                </div>

                {/* Features */}
                <div className="space-y-4 mb-8">
                    {features.map((feature, i) => (
                        <div key={i} className="flex items-center gap-3 text-slate-300">
                            <div className="flex-shrink-0 p-1.5 rounded-lg bg-emerald-500/20 border border-emerald-500/30">
                                <Check className="h-4 w-4 text-emerald-400" />
                            </div>
                            <span>{feature.text}</span>
                        </div>
                    ))}
                </div>

                {/* Pricing */}
                <div className="bg-slate-800/50 rounded-xl p-6 mb-8 border border-slate-700/50">
                    <div className="text-center">
                        <p className="text-slate-400 text-sm mb-1">VIP Access</p>
                        <div className="flex items-baseline justify-center gap-1">
                            <span className="text-4xl font-bold text-white">Contact</span>
                            <span className="text-slate-400">Admin</span>
                        </div>
                        <p className="text-slate-500 text-sm mt-2">
                            Request VIP access from the administrator
                        </p>
                    </div>
                </div>

                {/* Actions */}
                <div className="space-y-3">
                    <Button
                        onClick={handleContactAdmin}
                        className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-3"
                    >
                        <Crown className="h-4 w-4 mr-2" />
                        Request VIP Access
                    </Button>
                    <Button
                        variant="ghost"
                        onClick={() => navigate(-1)}
                        className="w-full text-slate-400 hover:text-white"
                    >
                        <ArrowLeft className="h-4 w-4 mr-2" />
                        Go Back
                    </Button>
                </div>

                {/* Footer note */}
                <p className="text-center text-slate-500 text-xs mt-6">
                    Already have VIP access? Try logging out and back in to refresh your session.
                </p>
            </Card>
        </div>
    );
};

export default SubscriptionPage;
